import parse from "html-react-parser";

const TextBlockRender = ({ text }: { text: string })  => {
    return(
        <section className="mb-12">
            <div className="general-content-text-wrapper text-arcticMist">
                {text && parse(text)}
            </div>
        </section>
    )
}

export default TextBlockRender;